export const BlogBanner = () => {
  return (
    <div className="bg-white">
      <div className="flex flex-col py-10 gap-6 md:gap-8 items-center md:container md:flex-row md:pb-12 lg:py-[72px]">
        <div className="px-4 md:px-0 flex flex-col gap-2 md:gap-6 md:w-[520px] lg:w-[780px]">
          <h1 className="text-black font-lateral1000 text-3xl md:text-4xl lg:text-5xl">
            EXETEL BLOG
          </h1>

          <p className="text-black font-light text-sm md:text-base lg:text-lg">
            Don't know your FTTBs from your FTTCs? Don't worry, we've got you
            covered. Our new blog is here to explain even the techiest tech
            jargon.
          </p>
        </div>
      </div>
    </div>
  );
};
